<template>
  <!-- Завода в наборе Element Plus нет, рисуем свой: труба и пилообразная
       крыша цехов. viewBox 1024 — как у иконок Element Plus, чтобы значок
       вставал с ними в один ряд без подгонки размеров.
       fill-rule evenodd: окна вырезаются из того же контура -->
  <svg
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    fill-rule="evenodd"
    aria-hidden="true"
  >
    <path
      d="M176 176h112v240h96v128l256-128v128l256-128v464H128V416h48V176zm48 464h96v96h-96v-96zm224 0h96v96h-96v-96zm224 0h96v96h-96v-96z"
    />
    <!-- Перечёркнутый — товар не производится, продаётся только из наличия.
         Светлая подложка отделяет черту от цехов, иначе она в них тонет -->
    <template v-if="crossed">
      <path d="M96 96L928 928" stroke="#fff" stroke-width="150" stroke-linecap="round" />
      <path d="M96 96L928 928" stroke="currentColor" stroke-width="72" stroke-linecap="round" />
    </template>
  </svg>
</template>

<script setup>
defineProps({ crossed: { type: Boolean, default: false } });
</script>
